import { API } from '@/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const createPtal = createAsyncThunk(
  'ptal/createPtal',
  async ({ objective, region, spo }: { objective: string; region: string; spo: string }) =>
    API.ptals.createPtal({ objective, region, spo }),
);

export const retrievePtal = createAsyncThunk('ptal/getPtal', async ({ jobId }: { jobId: string }) =>
  API.ptals.getPtal({ jobId }),
);
